import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    accountID: undefined,
    companyID: undefined,
    header: undefined,
    accessToken: undefined,
    userType: undefined,
  },
  mutations: {
    accountID (state, accountID) {
      state.accountID = accountID
    },
    companyID (state, companyID) {
      state.companyID = companyID
    },
    header (state, header) {
      state.header = header
    },
    userType (state, userType) {
      state.userType = userType
    },
    bearer (state, bearer) {
      state.bearer = bearer
    },
    accessToken (state, accessToken) {
      state.accessToken = accessToken
    },
  },
  actions: {
    logout({state, commit}) {
      commit('companyID', undefined)
      commit('accountID', undefined)
      commit('userType', undefined)
      commit('accessToken', undefined)
      commit('header', undefined)

      window._VUE_STATE = state

      if (localStorage) {
        localStorage.removeItem('login-information')
      }
    },
    login ({ state, commit }, { accountID, accountPassword }) {

      const s = 'Basic ' + window.btoa('thinktube:secret')

      return new Promise((resolve, reject) => {

        let xhr = new XMLHttpRequest()

        //TODO axio가 안 먹어서 만들었다.
        const baseURL = process.env.API_SERVER
        xhr.open('POST', `${baseURL}/oauth/token`)
        xhr.onreadystatechange = function () {

          if (xhr.readyState < 4) {
            return
          }

          // Process our return data
          if (xhr.status >= 200 && xhr.status < 300) {

            if (xhr.response) {
              let response = xhr.response.replace(/^\n|\n$|\n/g, '')
              response = response.replace(/^\r|\r$|\r/g, '')
              response = response.replace(/\t/g, '')

              const data = JSON.parse(response)

              commit('companyID', data.company_id)
              commit('accountID', data.id)
              commit('userType', data.user_type)
              commit('accessToken', data.access_token)
              commit('header', 'bearer ' + data.access_token)
              window._VUE_STATE = state

              if (localStorage) {
                localStorage.setItem('login-information', JSON.stringify({
                  'companyID': state.companyID,
                  'accountID': state.accountID,
                  'userType': state.userType,
                  'accessToken': state.accessToken,
                  'header': state.header,
                }))
              }

              resolve({ data: data })
            }

          } else  {
            if (xhr.response) {
              const parse = JSON.parse(xhr.response)
              if (parse.error === 'invalid_grant') {
                reject('ID/PASSWORD 가 맞지 않습니다.')
              } else {
                console.log('WTF?')
                console.log(xhr)
                reject(xhr.response)
              }
            }
          }
        }

        xhr.setRequestHeader('Content-Type', 'application/x-www-form-urlencoded')

        xhr.setRequestHeader('Accept', 'application/json')
        xhr.setRequestHeader('Authorization', s)

        xhr.send(`grant_type=password&username=${accountID}&password=${accountPassword}`)
      })
    },
  },
  getters: {
    isLoggedIn: state => {
      return state.companyID && state.companyID
    },
  },
})




// WEBPACK FOOTER //
// ./src/stores.js